export default {"src":"/_next/static/media/generic-thumbnail.a3e496fe.svg","height":81,"width":61,"blurWidth":0,"blurHeight":0};